import React from 'react'
import {Tabs, Tab, DropdownButton, MenuItem, ButtonToolbar, FormControl, Button} from 'react-bootstrap'
import FontAwsome from 'react-fontawesome'
import {connect} from 'react-redux'
import AssetWorkDocGenForm from './AssetWorkDocGenForm'
// import WorkDocCheckCarDoc from '../../workdoc/WorkDocCheckCarDoc'
import AssetVehicleServiceDoc from '../AssetVehicleServiceDoc'
import SWTWorkNote from '../../workdoc/SWTWorkNote'
import WorkDocAttachmentDoc from '../../workdoc/WorkDocAttachmentDoc'
// import WorkDocTimeline from '../../workdoc/WorkDocTimeline'
import WorkdocStore from 'stores/WorkdocStore'
import { Box } from 'reactjs-admin-lte'
import {Switch,Route,withRouter} from 'react-router-dom'
import ConfirmPopup from 'component/element/ConfirmPopup'
import './assetwork.css'
const NotificationSystem = require('react-notification-system')
class AssetWorkDocEntryView extends React.Component {

  constructor(...args) {
    super(...args);

    // this.state = {activeKey:'info',loading:false,showInput:false,isEdit:false,_value:this.props.workNo,_workNo:this.props.workNo}
    this.state = {
        activeKey:'info',
        loading:false,
        showInput:false,
        isEdit:false,
        _value:this.props.workNo,
        _workNo:this.props.workNo,
        showConfirm:false,
        showConfirmStatus:false,
        confirmStatus:undefined,
        showConfirmPayment:false,
        confirmPayment:undefined,
        showGen:false,
        work_no:'',
        status:'0',
        deleted:'0'
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.setTab()
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&newProps.show!==this.props.show) {
        this.setTab()
        if (newProps.action==='edit'&&newProps.workNo!=='') {
            this.setState({showGen:true,work_no:newProps.workNo,_value:newProps.workNo,_workNo:newProps.workNo})
        } else {
            WorkdocStore.loadGenerateNextWorkId((result)=>{
                this.setState({showGen:true,work_no:result.work_no,_value:result.work_no,_workNo:result.work_no})
            })
        }
    }
  }

  setTab() {
    let {location} = this.props
    if (location.pathname==='/work/tyre')
        this.onTabsSelect('tyre')
    else if (location.pathname==='/work/note')
        this.onTabsSelect('note')
    else if (location.pathname==='/work/attachment')
        this.onTabsSelect('attachment')
    else
        this.onTabsSelect('info')
  }

  onTabsSelect(key) {
     this.setState({activeKey:key})
     this.props.history.push({pathname:'/work/'+key,search: '?workNo='+this.props.workNo,state: { workNo:this.props.workNo }})
  }

  onWoChange(e) {
    let {_workNo,_value} = this.state
    _value = e.target.value
    if (_value===_workNo) {
        this.setState({isEdit:false})
    } else {
        this.setState({isEdit:true})
    }
    this.setState({_value:_value})
  }

  onWoSaveClick() {
    this.setState({showConfirm:true})
  }

  onConfirm() {
    let {_value,_workNo} = this.state
    let postData = {new_val:_value,old_val:_workNo}
    WorkdocStore.saveRenameDoc(postData,(result)=>{
        if (result.status==='OK') {
            this.setState({_workNo:_value,isEdit:false,showInput:false,showConfirm:false})
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'ทำรายการสำเร็จ',
                level: 'info',
                position: 'tc'
            });
        }
    },(fail)=>{
        if (fail.status==='ERROR') {
            this.setState({_value:_workNo,isEdit:false,showInput:false,showConfirm:false})
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: fail.result,
                level: 'error',
                position: 'tc'
            });
        }    
    })
  }

  onStatusSelect(key) {
    this.setState({confirmStatus:key,showConfirmStatus:true})
  }

  onConfirmStatus() {
    let {confirmStatus,_workNo} = this.state
    if (confirmStatus==='doc_cancel'||confirmStatus==='doc_recover') {
        let action = confirmStatus==='doc_cancel'?'cancel':'recover'
        WorkdocStore.saveAssetWork(action,_workNo,(result)=>{
            if (result.status==='OK') {
                this.setState({confirmStatus:undefined,showConfirmStatus:false})
                this._notificationSystem.addNotification({
                    title: 'แจ้งเตือน',
                    message: 'ทำรายการสำเร็จ',
                    level: 'info',
                    position: 'tc'
                });
                if (confirmStatus==='doc_cancel') {
                    this.onReturnDeleted('1')
                } else {
                    this.onReturnDeleted('0')
                }
            }
        },()=>{
            this.setState({confirmStatus:undefined,showConfirmStatus:false})
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'ทำรายการไม่สำเร็จ',
                level: 'error',
                position: 'tc'
            });
        })
    } else if (confirmStatus==='doc_delete') {
        WorkdocStore.delAssetWork(_workNo,(result)=>{
            if (result.status==='OK') {
                this.setState({confirmStatus:undefined,showConfirmStatus:false})
                this._notificationSystem.addNotification({
                    title: 'แจ้งเตือน',
                    message: 'ทำรายการสำเร็จ',
                    level: 'info',
                    position: 'tc'
                });
                setTimeout(()=>{
                    this.onClose()
                },1000)
            }
        },()=>{
            this.setState({confirmStatus:undefined,showConfirmStatus:false})
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'ทำรายการไม่สำเร็จ',
                level: 'error',
                position: 'tc'
            });
        })
    } else {
        let status = (confirmStatus==='doc_fixing'||confirmStatus==='doc_request_edit'?'1':confirmStatus==='doc_job_done'?'3':'')
        let postData = {work_no:_workNo,status:status}
        WorkdocStore.saveAssetWorkStatus(postData,(result)=>{
            if (result.status==='OK') {
                this.setState({confirmStatus:undefined,showConfirmStatus:false})
                this._notificationSystem.addNotification({
                    title: 'แจ้งเตือน',
                    message: 'ทำรายการเปลี่ยนสถานะสำเร็จ',
                    level: 'info',
                    position: 'tc'
                });
                this.onReturnStatus(status)
            }
        },()=>{
            this.setState({confirmStatus:undefined,showConfirmStatus:false})
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'ทำรายการไม่สำเร็จ',
                level: 'error',
                position: 'tc'
            });    
        })
    }    
  }

  onConfirmPayment() {
    let {_workNo} = this.state
    let postData = {wo:_workNo}
    WorkdocStore.saveWorkPaymentStatus(postData,(result)=>{
        if (result.status==='OK') {
            this.setState({confirmPayment:undefined,showConfirmPayment:false})
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'ทำรายการเปลี่ยนสถานะการชำระเงินสำเร็จ',
                level: 'info',
                position: 'tc'
            });
        }
    },()=>{
        this.setState({confirmPayment:undefined,showConfirmPayment:false})
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'ทำรายการไม่สำเร็จ',
            level: 'error',
            position: 'tc'
        });    
    })
  }

  onClose() {
        this.setState({showGen:false})        
        this.props.onClose()

        //Push History
        this.props.history.push({pathname:'/work/info',state: { workNo:'' }})        
  }

  onReturnStatus(status) {
      this.setState({status:status})
  }

  onReturnDeleted(deleted) {
    this.setState({deleted:deleted})
  }

  renderTab0() {
      return(
            <div style={{padding:'10px'}}>
                <AssetWorkDocGenForm
                    show={this.state.showGen}
                    editMode={this.props.editMode}
                    action={this.props.action}
                    workNo={this.state.work_no}
                    status={this.state.status}
                    deleted={this.state.deleted}
                    onClose={this.onClose.bind(this)}
                    onUpdateAction={this.props.onUpdateAction}
                    onReturnStatus={this.onReturnStatus.bind(this)}
                    onReturnDeleted={this.onReturnDeleted.bind(this)}
                />
            </div>
      )
  }

//   renderTab1() {
//     return(
//           <div style={{padding:'10px'}}>
//                 <WorkDocCheckCarDoc
//                     workNo={this.props.workNo}
//                 />
//           </div>
//     )
//   }
  
  renderTab2() {
    return(
          <div style={{padding:'10px'}}>
                <AssetVehicleServiceDoc
                    mode='tyre-work-doc-entry-view'
                    showNewItem={true}
                    workNo={this.props.workNo}
                    show={this.props.show}
                    onClose={this.onClose.bind(this)}
                />
          </div>
    )
  }

  renderTab3() {
    return(
          <div style={{padding:'10px'}}>
                <SWTWorkNote
                    workNo={this.props.workNo}
                    mode='assetwork'
                />
          </div>
    )
  }

  renderTab4() {
    return(
          <div style={{padding:'10px'}}>
                <WorkDocAttachmentDoc
                    workNo={this.props.workNo}
                    mode='assetwork'
                />
          </div>
    )
  }

//   renderTab5() {
//     return(
//           <div style={{padding:'10px'}}>
//                 <WorkDocTimeline
//                     workNo={this.props.workNo}
//                 />
//           </div>
//     )
//   }

  renderStatus() {
    let {status} = this.state
    if (status==='1') {
        return(<span className="label label-warning"><FontAwsome name='wrench' />&nbsp;อยู่ระหว่างงาน</span>)
    } else if (status==='3') {
        return(<span className="label label-success"><FontAwsome name='thumbs-o-up' />&nbsp;ปิดจบงาน</span>)
    } else {
        return(<span className="label label-default">เริ่มต้น</span>)
    }
  }

  renderStatusDeleted() {
    let {deleted} = this.state
    if (deleted==='1') {
        return(<span className="label label-danger"><FontAwsome name='ban' />&nbsp;ยกเลิก</span>)
    } else {
        return('')
    }
  }

  render() {
    let {activeKey,loading,showInput,isEdit,_value,_workNo,showConfirm,showConfirmStatus,confirmStatus,showConfirmPayment,confirmPayment,status,deleted} = this.state
    let {action} = this.props
    let titleTab0 = (<div><FontAwsome name="car" />&nbsp;ข้อมูลทั่วไป</div>)
    // let titleTab1 = (<div><FontAwsome name="wrench" />&nbsp;ตรวจรับรถก่อนซ่อม</div>)
    let titleTab2 = (<div><FontAwsome name="warning" />&nbsp;รายการใบงาน</div>)
    let titleTab3 = (<div><FontAwsome name="book" />&nbsp;บันทึกช่วยจำ</div>)
    let titleTab4 = (<div><FontAwsome name="archive" />&nbsp;รูปประกอบ</div>)
    // let titleTab5 = (<div><FontAwsome name="calendar-check-o" />&nbsp;บันทึกเหตุการณ์</div>)
    let titleMenu0 = (<span><FontAwsome name="print" />&nbsp;พิมพ์เอกสาร</span>)
    let titleMenu1 = (<span><FontAwsome name="list" />&nbsp;เปลี่ยนสถานะ</span>)
    return(
        <div>
            <div className='assetwork-content-header' style={{marginBottom:'15px'}}>
                <h1 style={{display:'flex'}}>
                    แก้ไขใบงานเลขที่&nbsp;
                    {showInput
                    ?
                    <div style={{display:'flex'}}>
                        <FormControl style={{width:'200px'}} value={_value} onChange={this.onWoChange.bind(this)} />&nbsp;
                        {isEdit?<Button onClick={this.onWoSaveClick.bind(this)} style={{marginRight:'5px'}} bsSize='sm' bsStyle='success'><FontAwsome name='save' />&nbsp;บันทึก</Button> :''}
                        <Button bsSize='sm' onClick={()=>{this.setState({showInput:false})}}><FontAwsome name='close' />&nbsp;ปิด</Button>
                    </div>    
                    :
                    <span onClick={()=>{this.setState({showInput:true})}}>{_workNo}</span>
                    }
                </h1>
            </div>
            <Box loading={loading}>
                <Box.Header border={false} className='text-center'>
                    <Box.Title>ใบงานซ่อมรถ {this.renderStatus()} {this.renderStatusDeleted()}</Box.Title>
                    {action==='edit'
                    ?
                    <Box.Tools className='pull-right'>
                        <ButtonToolbar>
                            <DropdownButton className='bg-maroon' title={titleMenu0} id={'work-doc-entry-view-print-options'} onSelect={()=>{}}>
                                <MenuItem key={0} eventKey="checkingcar_doc">ใบตรวจสภาพรถก่อนซ่อม</MenuItem>
                                <MenuItem key={1} divider />
                                <MenuItem key={2} eventKey="checkingdamage_doc">รายการตรวจสอบความเสียหาย</MenuItem>
                                <MenuItem key={3} eventKey="fixinglistoncar_doc">รายการซ่อมติดหน้ารถ</MenuItem>            
                            </DropdownButton>
                            <DropdownButton bsStyle={'primary'} title={titleMenu1} id={'work-doc-entry-view-menu-options'} onSelect={this.onStatusSelect.bind(this)}>
                                {status==='3'&&deleted!=='1'?<MenuItem key={0} eventKey="doc_request_edit"><FontAwsome name='exclamation-triangle' className='text-red'/>&nbsp;ขอแก้ไขใบงาน</MenuItem>:''}
                                {status!=='3'&&deleted!=='1'?<MenuItem key={0}>เปลี่ยนสถานะงานเป็น</MenuItem>:''}
                                {status!=='3'&&deleted!=='1'?<MenuItem key={1} eventKey="doc_fixing"><FontAwsome name='wrench' className='text-yellow'/>&nbsp;อยู่ระหว่างงาน</MenuItem>:''}
                                {status!=='3'&&deleted!=='1'?<MenuItem key={2} eventKey="doc_job_done"><FontAwsome name='thumbs-o-up' className='text-green'/>&nbsp;ปิดจบงาน</MenuItem>:''}  
                                {deleted!=='1'?<MenuItem key={99} divider />:''}
                                {deleted==='1'
                                ?<MenuItem key={3} eventKey="doc_recover"><FontAwsome name='ban' className='text-red'/>&nbsp;ปลดยกเลิกใบงาน</MenuItem>
                                :<MenuItem key={3} eventKey="doc_cancel"><FontAwsome name='ban' className='text-red'/>&nbsp;ยกเลิกใบงาน</MenuItem>
                                }
                                <MenuItem key={98} divider />
                                <MenuItem key={4} eventKey="doc_delete"><FontAwsome name='trash' className='text-red'/>&nbsp;ลบใบงานทิ้งถาวร</MenuItem>
                            </DropdownButton>
                        </ButtonToolbar>
                    </Box.Tools>
                    :''}
                </Box.Header>
                <Box.Body>
                    <Tabs 
                        // defaultActiveKey={'info'} 
                        activeKey={activeKey}
                        id='workdoc-entry-view-tabs'
                        onSelect={this.onTabsSelect.bind(this)}
                    >
                        <Switch>
                            <Route exact path="/work/info" render={(props) => this.renderTab0()}/>                            
                            {/* <Route exact path="/work/checkcar" render={(props) => this.renderTab1()}/> */}
                            <Route exact path="/work/tyre" render={(props) => this.renderTab2()}/>
                            <Route exact path="/work/note" render={(props) => this.renderTab3()}/>
                            <Route exact path="/work/attachment" render={(props) => this.renderTab4()}/>
                            {/* <Route exact path="/work/timeline" render={(props) => this.renderTab5()}/> */}
                            <Route render={(props) => this.renderTab0()}/>                         
                        </Switch>
                        <Tab eventKey={'info'} title={titleTab0}></Tab>
                        {/* <Tab eventKey={'checkcar'} title={titleTab1}></Tab> */}
                        {action==='edit'?<Tab eventKey={'tyre'} title={titleTab2}></Tab>:''}
                        {action==='edit'?<Tab eventKey={'note'} title={titleTab3}></Tab>:''}
                        {action==='edit'?<Tab eventKey={'attachment'} title={titleTab4}></Tab>:''}
                        {/* <Tab eventKey={'timeline'} title={titleTab5}></Tab> */}
                    </Tabs>
                </Box.Body>
            </Box>
            <ConfirmPopup
                show={showConfirm}
                message='ยืนยันการแก้ไขเลขที่ใบงาน ?'
                onConfirm={this.onConfirm.bind(this)}
                onHide={()=>{this.setState({showConfirm:false})}}
            />
            <ConfirmPopup
                show={showConfirmStatus}
                message={(confirmStatus==='doc_request_edit'?'ต้องการปรับสถานะใบงาน เพื่อแก้ไข ?':confirmStatus==='doc_cancel'?'ต้องการยกเลิกใบงาน ?':confirmStatus==='doc_recover'?'ต้องการปลดยกเลิกใบงาน ?':confirmStatus==='doc_delete'?'ต้องการลบใบงานทิ้งถาวร ?':'ต้องการเปลี่ยนสถานะเป็น '+(confirmStatus==='doc_fixing'?'อยู่ระหว่างซ่อม':confirmStatus==='wait_for_customer'?'ส่งมอบรถให้ลูกค้า':confirmStatus==='doc_job_done'?'ปิดจบงาน':'')+' ?')}
                onConfirm={this.onConfirmStatus.bind(this)}
                onHide={()=>{this.setState({showConfirmStatus:false,confirmStatus:undefined})}}
            />
            <ConfirmPopup
                show={showConfirmPayment}
                message={'ต้องการเปลี่ยนสถานะชำระเงินเป็น '+(confirmPayment==='doc_credit_pay'?'ชำระเงินแล้ว':'')+' ?'}
                onConfirm={this.onConfirmPayment.bind(this)}
                onHide={()=>{this.setState({showConfirmPayment:false,confirmPayment:undefined})}}
            />
            <NotificationSystem ref="notificationSystem" />
        </div>
    )
  }
}

AssetWorkDocEntryView.defaultProps = {
  onClose : ()=>{},
  editMode:false,
}

const mapStateToProps = (state) => ({
  store: state,
});


const _Connect = connect(
    mapStateToProps
)(AssetWorkDocEntryView);

export default withRouter(_Connect) 
//export default _Connect;



// WEBPACK FOOTER //
// ./src/view/tyre/workdoc/AssetWorkDocEntryView.js